import { ComponentsOverrides, Theme } from "@mui/material";

type MuiTabs = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTabs"];
};

const muiTabs: MuiTabs = {
  styleOverrides: {
    root: {
      minHeight: "64px",
    },
    flexContainer: {
      height: "100%",
    },
  },
};

export default muiTabs;
